const UIButton = ({
  children,
  onClick,
  onMouseEnter,
  className,
  dark = false,
  disabled = false,
  outline = false,
  secondary = false,
  tertiary = false,
  style,
  fullWidth = false,
  ...rest
}) => {

  const primaryButtonClass = outline ? "border-primary border-[1.5px] text-principal" : "bg-principal text-white";
  const secondaryButtonClass = outline ? "border-[#2A2A2A] hover:border-primary hover:text-primary bg-white border text-[#2A2A2A]" : "text-white bg-slate-600";
  const tertiaryButtonClass = outline ? "border-bg-primary border-[1.5px] text-principal" : "bg-principal text-black";
  const isSecondary = !secondary ? `bg-primary hover:bg-green-700  ${primaryButtonClass}` : `hover:bg-slate-800 hover:text-white ${secondaryButtonClass}`
  const defaultClass = tertiary ? `bg-white hover:bg-green-700 ${tertiaryButtonClass}` : isSecondary

  return (
    <div className={`flex justify-center items-center `} onMouseEnter={onMouseEnter}>
      <button
        disabled={disabled}
        className={` outline-none flex px-8 font-BNPPSquareBold items-center justify-center h-[48px] rounded-[4px] p-3 transition-all 
              ${fullWidth && "w-full"}
              ${defaultClass}
              ${dark && "bg-transparent border-white border text-white hover:bg-transparent"}
              ${disabled && "bg-zinc-300 hover:bg-zinc-300 cursor-not-allowed"}
              ${className}
            `}
        style={{ ...style }}
        onClick={onClick}
        {...rest}
      >
        {children}
      </button>
    </div>
  );
};

export default UIButton;